import React, { useEffect, useState } from "react";
import classes from "./ShifuPage.module.css";
import shifu_logos from "../assets/shifu_logos.png";
import menu_icon from "../assets/menu_icon.svg";
import close_icon from "../assets/close_icon.png";
import ShifuForm from "./ShifuForm";

const ShifuHeader = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);

      if (!mobile) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleWhyShifuClick = () => {
    const section = document.getElementById("whyShifu");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  const handleHowShifuClick = () => {
    const section = document.getElementById("howShifuWorks");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleCaseStudyClick = () => {
    const section = document.getElementById("caseStudy");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  const handleCalendarOpen = () => {
    window.open("https://calendar.app.google/f8rR8BEaYL3ECTpa6", "_blank");
  };

  return (
    <>
      <header className={classes.header}>
        <img src={shifu_logos} alt="Shifu" className={classes.logo} />

        {!isMobile && (
          <>
            <nav className={classes.nav}>
              <span style={{ cursor: "pointer" }} onClick={handleWhyShifuClick}>
                WHY SHIFU?
              </span>

              <span style={{ cursor: "pointer" }} onClick={handleHowShifuClick}>
                HOW SHIFU WORKS?
              </span>
              <span
                style={{ cursor: "pointer" }}
                onClick={handleCaseStudyClick}
              >
                CASE STUDY
              </span>
            </nav>

            <button className={classes.headerBtn} onClick={handleCalendarOpen}>
              INITIATE PILOT ↗
            </button>
          </>
        )}

        {isMobile && (
          <button
            className={classes.mobileMenu}
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <img src={menuOpen ? close_icon : menu_icon} alt="menu" />
          </button>
        )}
      </header>

      {isMobile && (
        <div
          className={`${classes.mobilePanel} ${menuOpen ? classes.open : ""}`}
        >
          <span style={{ cursor: "pointer" }} onClick={handleWhyShifuClick}>
            {" "}
            WHY SHIFU?
          </span>
          <span style={{ cursor: "pointer" }} onClick={handleHowShifuClick}>
            {" "}
            HOW SHIFU WORKS?
          </span>
          <span style={{ cursor: "pointer" }} onClick={handleCaseStudyClick}>
            {" "}
            CASE STUDY
          </span>
          <button className={classes.mobileCta} onClick={handleCalendarOpen}>
            INITIATE PILOT ↗
          </button>
        </div>
      )}
    </>
  );
};

export default ShifuHeader;
